import React, { useEffect, useState } from "react";
import { useState as useAppState } from "../state/useState";
import { order } from "../service/RechargeService";
import { redirectTo } from "../state/action";
import { ConfirmMobileData } from "./ConfirmMobileData";
import { ConfirmVoucherData } from "./ConfirmVoucherData";
import Loader from "react-loader-spinner";

const RfPayment = 1
const XPayPayment = 2

export function ConfirmData({ history }) {

    let [state, dispatch] = useAppState();
    let [clicked, setClicked] = useState(false);
    let [paymentType, setPaymentType] = useState(1);
    let [encType, setEncType] = useState(1);


    function isRfAllowed() {
        if (state.selectedOperator && state.selectedOperator.productType == 1) return true
        else if (state.selectedOperator && state.selectedOperator.productType == 2 && paymentType == 2) return true
        else return false
    }

    useEffect(() => {
        if (state.selectedOperator == null) {
            history.push("/");
        }
    }, []);

    useEffect(() => {
        console.log("clicked is true")
        clicked && order(paymentType, state.selectedOperator.productType, state.selectedOperator.index, state.selectedOperator.voucherType, state.phoneNumber, state.amount, state.deliveryType, state.membershipNumber,
            state.usernameSurname, state.email)
            .then(result => {
                console.log("result", result);
                if (result.success) {
                    console.log("redirect to ", result.redirectTo);
                    dispatch(redirectTo(result.redirectTo, "POST", result.redirectParams));
                    history.push("/redirect/" + encType)
                } else if (result.msg) {
                    let message = encodeURI(result.msg)
                    history.push("/message/" + message);
                } else {
                    history.push("/message");
                }
                return result;
            })
            .catch(error => {
                console.log("error", error);
                history.push("/message");
            })
    }, [clicked])

    function onSubmit(event, paymentType, encType) {
        event.preventDefault();
        setPaymentType(paymentType)
        setEncType(encType)
        setClicked(true)
    }

    function render() {
        let operator = state.selectedOperator;
        switch (operator && operator.index) {
            case 3:
            case 1:
            case 2:
            case 4:
            case 6:
                return <ConfirmMobileData operatorName={state.selectedOperator.name} phoneNumber={state.phoneNumber}
                    amount={state.amount} />;
            case 7:
            case 8:
                return <ConfirmVoucherData deliveryType={state.deliveryType}
                    operatorName={state.selectedOperator.name}
                    amount={state.amount} membershipNumber={state.membershipNumber}
                    email={state.email} userName={state.usernameSurname} />
            default:
                return null;
        }
    }

    return <>
        <div class="page_title2">
            <div class="container">

                <div class="title"><h1>Potvrda unesenih podataka</h1></div>
            </div>
        </div>


        <div class="clearfix"></div>

        <div class="container">

            <div class="content_fullwidth">

                <div class="reg_form">
                    <p><h3 class="nocaps">Molim Vas da provjerite ispravnost podataka prije izvršenja dopune.</h3>
                    </p>
                    {render()}
                    {(!clicked) ?
                        <div><h4 class="nocaps">Ukoliko su svi podaci tačni, izaberite način uplate:</h4>
                            {isRfAllowed() &&
                                <>
                                    <a href="" onClick={event => onSubmit(event, RfPayment, 1)}><img
                                        src={require("../assets/images/rzb_epay.jpg")} align="left" height="90" alt="" /></a>
                                    <p></p>
                                </>
                            }

                            <a href="" onClick={event => onSubmit(event, XPayPayment, 2)}><img
                                src={require("../assets/images/dugme_xPAY_transparentna_podloga.png")} height="90"
                                align="right"
                                alt="" /></a></div> :
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "center",
                            alignContent: "start",
                            justifyContent: "start"
                        }}>
                            <Loader
                                type="Puff"
                                color="#EC258F"
                                height="70"
                                width="70"
                            />
                            <div style={{ width: "10px" }}></div>
                            <h3 class="nocaps">Obrada...</h3>
                        </div>
                    }

                    <p></p>
                    <br />
                    <br />
                    <br />
                    <br />

                    <blockquote><p class="nocaps">Transakcija ne podliježe nikakvim dodatnim naknadama.</p>
                    </blockquote>
                    <div class="left"><a href="javascript:undefined" onClick={() => history.push("/")}
                        class="knowmore_but"><i
                            class="fa fa-hand-o-left fa-lg"></i> NAZAD</a></div>
                </div>


            </div>

        </div>

        <div class="clearfix margin_top7"></div>

        <div class="clearfix"></div>

    </>
}
